import axios from 'axios';

// 장소 검색 (Google Places API - Text Search)
export const searchAddress = (query, succFunc) => {
    let url = "https://places.googleapis.com/v1/places:searchText";

    axios.post(url, {
        textQuery: query,
        languageCode: navigator.language.split('-')[0]
    }, {
        headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": "AIzaSyCwvZc2J7jYg29rAzcQW68cxrVYp37E2Cg",
            "X-Goog-FieldMask": "places.displayName,places.location,places.formattedAddress"
        }
    })
        .then((response) => {
            if (succFunc && response.data && response.data.places) {
                let results = response.data.places.map((p) => ({
                    display_name: p.displayName.text + " - " + p.formattedAddress,
                    lat: String(p.location.latitude),
                    lon: String(p.location.longitude)
                }));
                succFunc(results);
            }
        })
        .catch((err) => {
            console.error("Google Places search error:", err);
        });
};

// 역지오코딩 (Nominatim, x=lng, y=lat)
export const getAddress = (x, y, succFunc) => {
    let url = "https://nominatim.openstreetmap.org/reverse?lat=" + y + "&lon=" + x + "&format=json&accept-language=ko";

    axios.get(url)
        .then((response) => {
            let resp = response.data;
            let addressName = "";
            if (resp.address) {
                let a = resp.address;
                let parts = [];
                if (a.country) parts.push(a.country);
                if (a.state || a.province) parts.push(a.state || a.province);
                if (a.city || a.town || a.village || a.county) {
                    parts.push(a.city || a.town || a.village || a.county);
                }
                if (a.city_district || a.borough) {
                    parts.push(a.city_district || a.borough);
                }
                if (a.suburb || a.neighbourhood || a.quarter || a.village) {
                    let dong = a.suburb || a.neighbourhood || a.quarter;
                    if (!dong && a.village && !parts.includes(a.village)) {
                        dong = a.village;
                    }
                    if (dong && !parts.includes(dong)) {
                        parts.push(dong);
                    }
                }
                addressName = parts.join(" ");
            } else {
                addressName = resp.display_name || "";
            }
            if (succFunc) {
                succFunc({
                    address_name: addressName,
                    display_name: resp.display_name || addressName
                });
            }
        })
        .catch((err) => {
            console.error("Nominatim API error:", err);
        });
};
